import React from 'react';
import './IconicProjects.css';
import { ProjectCard } from '../../project/components/ProjectGrid';
import projectsInfo from '../../project/ProjectsInfo';
import 'react-multi-carousel/lib/styles.css';
import CorauselSlider from '../../../utility/components/CorauselSlider';

export const IconicProjects = () => {

    // Get chosen projects by their ids
    const chosenProjects = [
        {id: 1},
        {id: 2},
        {id: 3},
        {id: 4},
        {id: 5},
        {id: 6},
    ]

    const getProjectsByIds = (projectIds) => {
        return projectsInfo.filter(project => projectIds.includes(project.id));
    };

    const selectedProjects = getProjectsByIds(chosenProjects.map(project => project.id));

    const renderCard = (card) => (
        <ProjectCard
            key={card.id}
            id={card.id}
            showcaseImg={card.showcaseImg}
            showcasename={card.showcaseName}
        />
    );

    return (
        <section className="iconic-projects">
            <div className='iconic-projects__title-container'>
                <h1>Iconic Projects</h1>
            </div>
            
            <CorauselSlider cards={selectedProjects} renderCard={renderCard} sliderClassCss={'carousel-slider'} showProgressBar={false}/>
        
        </section>
    );
};